import React, { useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/jKQbRfZGJ5hCtmpWHBodP2/Screenshot_1.png', 'https://cdn.magicpatterns.com/uploads/4XGSvsHKphLsdXQbzvtJS9/Screenshot_2.png', 'https://cdn.magicpatterns.com/uploads/cc9U8xvbbhTM8KWxR5svKi/Screenshot_3.png', 'https://cdn.magicpatterns.com/uploads/sRHCqHr4M42pYRuT1sdfMX/Screenshot_4.png', 'https://cdn.magicpatterns.com/uploads/99oYsDtnbKFZXw4ubvCuos/Screenshot_5.png'];
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="bg-brand-grayLight py-16 px-5 overflow-hidden" data-id="element-252">
      <div className="max-w-xl mx-auto text-center" data-id="element-253">
        <h2 className="text-2xl md:text-3xl font-black text-slate-900 mb-10 flex items-center justify-center gap-3" data-id="element-254">
          📸 Mirá el material por dentro
        </h2>

        <div className="flex items-center justify-between mb-8 text-slate-400 px-2" data-id="element-255">
          <button onClick={prev} className="p-3 hover:text-[#C8A96B] transition-colors bg-white rounded-xl shadow-sm border border-slate-100" aria-label="Anterior" data-id="element-256">
            <ChevronLeft size={24} data-id="element-257" />
          </button>

          <span className="uppercase tracking-[0.2em] text-slate-300 text-[12px] font-[600]" data-id="element-258">
            Desliza para ver más
          </span>

          <div className="flex items-center gap-6" data-id="element-259">
            <button onClick={next} className="p-3 hover:text-[#C8A96B] transition-colors bg-white rounded-xl shadow-sm border border-slate-100" aria-label="Siguiente" data-id="element-260">
              <ChevronRight size={24} data-id="element-261" />
            </button>
          </div>
        </div>

        <div className="relative aspect-[3/4] md:aspect-[4/5] overflow-hidden mb-10 rounded-3xl bg-white shadow-xl border border-slate-100" data-id="element-262">
          <AnimatePresence mode="wait" data-id="element-263">
            <motion.img key={currentIndex} src={images[currentIndex]} alt={`Vista del producto ${currentIndex + 1}`} loading="lazy" width="600" height="800" decoding="async" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="w-full h-full object-contain p-4" data-id="element-264" />
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-3" data-id="element-265">
          {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-10 bg-[#C8A96B]' : 'w-2 bg-slate-200'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-266" />)}
        </div>
      </div>
    </section>;
}